import { useCallback, useState } from 'react';
import { findLast } from 'lodash';
import { videoPriority } from 'const';
import useIsTrackEnabled from './useIsTrackEnabled';
import useVideoContext from './useVideoContext';

export default () => {
  const {
    room,
    localTracks,
    onError,
    settings: { audioInputId },
    setSettings,
    getLocalAudioTrack,
  } = useVideoContext();

  const hasAudioDeviceSelected = audioInputId && audioInputId.length > 0;
  const localParticipant = room?.localParticipant;
  const audioTrack = findLast(localTracks, (track) => track.kind === 'audio');
  const isEnabled = useIsTrackEnabled(audioTrack);
  const [isPublishing, setIsPublishing] = useState(false);

  const toggleAudioEnabled = useCallback(() => {
    if (audioTrack) {
      setSettings((st) => ({ ...st, audioInputEnabled: !audioTrack.isEnabled }));
      // eslint-disable-next-line no-unused-expressions
      audioTrack.isEnabled ? audioTrack.disable() : audioTrack.enable();
    } else if (!isPublishing) {
      setIsPublishing(true);
      setSettings((st) => ({ ...st, audioInputEnabled: true }));
      getLocalAudioTrack(true)
        .then((track) => {
          if (track) {
            localParticipant
              ?.publishTrack(track, {
                priority: videoPriority.standard,
              })
              .then(() => {
                track.enable();
              });
          }
        })
        .catch(onError)
        .finally(() => setIsPublishing(false));
    }
  }, [audioTrack]);

  return [hasAudioDeviceSelected, isEnabled, toggleAudioEnabled];
};
